export const WEBVIEW_LOCATION_CHANGE = 'WEBVIEW_LOCATION_CHANGE';
export const WEBVIEW_FILE_UPLOAD = 'WEBVIEW_FILE_UPLOAD';
export const WEBVIEW_SET_REFRESH_TOKEN = 'WEBVIEW_SET_REFRESH_TOKEN';
export const WEBVIEW_GET_REFRESH_TOKEN = 'WEBVIEW_GET_REFRESH_TOKEN';
export const WEBVIEW_INITIALIZE = 'WEBVIEW_CHECK_READY';
export const WEBVIEW_OPEN_EXTERNAL_LINK = 'WEBVIEW_OPEN_EXTERNAL_LINK';
export const WEBVIEW_ENSURE_SCROLL_STATE = 'WEBVIEW_ENSURE_SCROLL_STATE';
export const WEBVIEW_APP_REVIEW = 'WEBVIEW_APP_REVIEW';
export const WEBVIEW_CLIPBOARD_WRITE = 'WEBVIEW_CLIPBOARD_WRITE';

export const NATIVE_GO_TO = 'NATIVE_GO_TO';
export const NATIVE_GO_BACK = 'NATIVE_GO_BACK';
export const NATIVE_FILE_SELECTED = 'NATIVE_FILE_SELECTED';
export const NATIVE_GET_REFRESH_TOKEN_R = 'NATIVE_GET_REFRESH_TOKEN_R';
export const NATIVE_INITIALIZE_R = 'NATIVE_CHECK_READY_R';
export const NATIVE_SCROLL_TO_BOTTOM = 'NATIVE_SCROLL_TO_BOTTOM';
export const NATIVE_INVALID_PERMISSION = 'NATIVE_INVALID_PERMISSION';
export const NATIVE_APP_RE_ENTERED = 'NATIVE_APP_RE_ENTERED';

export const LOG = 'LOG';
